/**
 * Cấu hình lời thoại MÁY TRẠM KHO — hiện chỉ có case "sổ xưởng có mẻ mới".
 *
 * Dùng chung giao diện với hai màn cấu hình kia, chỉ khác tập case và bảng tra
 * placeholder (màn này chỉ có {nguoi_ghi} + {ten_so}). Tách ra vì người kho
 * không phải lướt qua cấu hình của bán hàng hay của xưởng vò, và ngược lại.
 */

import { createFileRoute } from '@tanstack/react-router'

import { StationVoiceSettingsView } from '@/components/station-voice/station-voice-settings-view'
import { isWarehouseStationCase } from '@/lib/station-voice-cases'
import { m } from '@/lib/paraglide/messages'

export const Route = createFileRoute(
    '/_app/_authed/_sidebar/settings/warehouse-station-voice',
)({ component: WarehouseStationVoicePage })

function WarehouseStationVoicePage() {
    return (
        <StationVoiceSettingsView
            title={m.station_voice_warehouse_title()}
            includeCase={isWarehouseStationCase}
        />
    )
}
